import { render, staticRenderFns } from "./addvalue.vue?vue&type=template&id=49570113&scoped=true&"
import script from "./addvalue.vue?vue&type=script&lang=js&"
export * from "./addvalue.vue?vue&type=script&lang=js&"
import style0 from "./addvalue.vue?vue&type=style&index=0&id=49570113&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49570113",
  null
  
)

export default component.exports